export default __webpack_public_path__ + "static/media/economic.b2dc3187.svg";